if (!customElements.get('component-newsletter-klaviyo')) {
  class NewsletterKlaviyo extends HTMLElement
  {
    constructor ()
    {
      super();

      this.submitBtn = this.querySelector('.submit--klaviyo');
      this.success = this.querySelector('#newsletter-klaviyo-success').closest('custom-modal');
      this.smsTerms = this.querySelector('[name="accepts_terms"]');
      this.phoneInput = this.querySelector('[name="phone"]');
      this.emailInput = this.querySelector('[name="email"]');
    }

    connectedCallback ()
    {
      this.submitBtn.addEventListener('click', (e) => {
        e.preventDefault();

        this.submit();
      });

      if (this.phoneInput) {
        this.phoneInput.addEventListener('input', (e) => {
          this.check();
        });
      }

      if (this.emailInput) {
        this.emailInput.addEventListener('input', (e) => {
          this.check();
        });
      }

      if (this.smsTerms) {
        this.smsTerms.addEventListener('change', (e) => {
          this.check();
        });

        this.check();
      }
    }

    phone ()
    {
      const prefixOption = this.querySelector('[name="phone--prefix"] option:checked');

      if (!this.phoneInput || !prefixOption || this.phoneInput.value.trim() === '') {
        return null;
      }

      return prefixOption.dataset.prefix + this.phoneInput.value;
    }

    email ()
    {
      return this.emailInput?.value;
    }

    error (err)
    {
      const div = this.querySelector('.klaviyo-error');

      div.style.display = 'none';
      div.querySelector('.klaviyo-error--email').style.display = 'none';
      div.querySelector('.klaviyo-error--phone').style.display = 'none';
      div.querySelector('.klaviyo-error--custom').style.display = 'none';

      if (!err) {
        return;
      }

      if (err.toLowerCase().indexOf('phone') > -1) {
        div.querySelector('.klaviyo-error--phone').style.display = 'block';
        div.style.display = 'block';
      } else if (err.toLowerCase().indexOf('email') > -1) {
        div.querySelector('.klaviyo-error--email').style.display = 'block';
        div.style.display = 'block';
      } else {
        div.querySelector('.klaviyo-error--custom').innerText = err;
        div.querySelector('.klaviyo-error--custom').style.display = 'block';
        div.style.display = 'block';
      }
    }

    check ()
    {
      let disabled = false;

      if (this.smsTerms && this.phone()) {
        disabled = !this.smsTerms.checked;
      }

      this.submitBtn.classList.toggle('disabled', disabled);
    }

    submit ()
    {
      if ((!this.email() && !this.phone())
        || this.submitBtn.classList.contains('disabled')
      ) {
        return;
      }

      window.Helpers.Klaviyo.subscribe(
        this.email(),
        this.phone(),
        window.Helpers.Config.integrations.klaviyo.routine_finder_list_id,
      ).then(data => {
        if (data.errors) {
          this.error(data.errors[0].detail);
        } else {
          this.error(null);
          requestAnimationFrame(() => {
            this.success.show();
          });
        }
      });
    }
  }
  customElements.define('component-newsletter-klaviyo', NewsletterKlaviyo);
}
